// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__1b8tr","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__bhnJF"};